var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnWeb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prdacw9xia)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.97 10.783a10.132 10.132 0 0 0 0-1.566A10.002 10.002 0 0 0 9.218.03 10.002 10.002 0 0 0 .03 10.782a10.002 10.002 0 0 0 10.752 9.188 10.002 10.002 0 0 0 9.188-9.187zm-8.285 7.856a8.81 8.81 0 0 0 6.954-6.954 16.544 16.544 0 0 1-4.946 2.008 16.544 16.544 0 0 1-2.008 4.946zm2.25-6.24c1.709-.451 3.357-1.201 4.864-2.25a9.208 9.208 0 0 0 0-.298 15.356 15.356 0 0 0-4.865-2.25c.232 1.59.232 3.207 0 4.797zm-1.26-5.074c.31 1.77.31 3.58 0 5.35-1.77.31-3.58.31-5.35 0a15.453 15.453 0 0 1 0-5.35 15.453 15.453 0 0 1 5.35 0zm1.018-1.018a16.546 16.546 0 0 1 4.946 2.008 8.81 8.81 0 0 0-6.954-6.954 16.545 16.545 0 0 1 2.008 4.946zM10.15 1.2a15.355 15.355 0 0 1 2.25 4.865 16.658 16.658 0 0 0-4.797 0c.45-1.71 1.2-3.358 2.25-4.865a8.875 8.875 0 0 1 .297 0zm-1.834.16A8.81 8.81 0 0 0 1.36 8.315a16.547 16.547 0 0 1 4.946-2.008A16.547 16.547 0 0 1 8.315 1.36zm-2.25 6.24c-1.709.451-3.357 1.201-4.864 2.25a8.875 8.875 0 0 0 0 .298 15.355 15.355 0 0 0 4.865 2.25 16.658 16.658 0 0 1 0-4.797zm.242 6.092a16.545 16.545 0 0 1-4.946-2.008 8.81 8.81 0 0 0 6.954 6.954 16.546 16.546 0 0 1-2.008-4.946zM9.85 18.8a15.356 15.356 0 0 1-2.25-4.865c1.59.232 3.207.232 4.797 0-.45 1.71-1.2 3.359-2.25 4.865a9.208 9.208 0 0 1-.297 0z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prdacw9xia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(180 10 10)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWeb1);
export default __webpack_public_path__ + "static/media/icn_web_1.e66a97acad7936327d028762a4225014.svg";
export { ForwardRef as ReactComponent };